import styled, { CSSObject } from "styled-components";

export const Container = styled.div<{ height?: number }>(({ height }) => ({
    overflow: "hidden",
    flex: 1,
    height: height ? `${height}px` : "auto",
}));

export const ScrollWrapper = styled.div<{ transition: string; transformY: string }>(({ transition, transformY }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column" as CSSObject["flexDirection"],
    transition: transition,
    transform: `translate3d(0, ${transformY}, 0)`,
}));
